import SmallCopyRight from 'components/SmallCopyRight';
import { goToDeliveryPrint } from 'pages/status/delivery/Utils';
import React, { useEffect, useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { showErrorMessage } from 'redux/actions/systemMessageActions';
import { createGlobalStyle } from 'styled-components';
const PublicStatusLoginPage = () => {
    const { vendorKey, accountNo, displayCd } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    //#region state hooks
    const [theAccountNo, setTheAccountNo] = useState('');
    const [theDisplayCd, setTheDisplayCd] = useState('');
    const [validated, setValidated] = useState(false);
    //#endregion
    //#region useEffect hooks
    useEffect(() => {
        document.title = 'Delivery Status System';
    }, []);
    useEffect(() => {
        if (!vendorKey || !accountNo || !displayCd) {
            return;
        }
        if (accountNo && displayCd && vendorKey) {
            setTheAccountNo(accountNo);
            setTheDisplayCd(displayCd);
            doLogin(accountNo, displayCd);
        }
    }, [accountNo, displayCd, vendorKey]);
    //#endregion

    //#region Events
    const handleLoginSubmit = (e) => {
        const form = e.currentTarget;
        const isValid = form.checkValidity();
        e.preventDefault();
        e.stopPropagation();

        setValidated(true);

        if (!isValid) {
            return;
        }
        doLogin(theAccountNo, theDisplayCd);
    };
    //#endregion
    //#region Helpers
    const doLogin = (theAccountNo, theDisplayCd) => {
        if (theAccountNo.trim() === '' || theDisplayCd.trim() === '') {
            setTheAccountNo(theAccountNo.trim());
            setTheDisplayCd(theDisplayCd.trim());
            dispatch(showErrorMessage({ message: 'Please enter valid information' }));
            return;
        }
        goToDeliveryPrint({
            account: theAccountNo ? theAccountNo.toString().trim() : theAccountNo,
            displayCd: theDisplayCd ? theDisplayCd.toString().trim() : theDisplayCd,
            vendorId: vendorKey,
            newPage: false,
            history,
            showBigger: true,
        });
    };
    //#endregion
    return (
        <>
            <Styles />
            <Container>
                <Row>
                    <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-sm-10 offset-sm-1 col-10 offset-1">
                        <Row id="loginContainer">
                            <Col md={{ span: 10, offset: 1 }}>
                                <h1 className="text-center">Delivery Status</h1>
                                <Form noValidate validated={validated} onSubmit={handleLoginSubmit}>
                                    <Form.Group>
                                        <Form.Label htmlFor="accountNo" className="required">
                                            Account # *
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            required
                                            id="accountNo"
                                            onChange={(e) => {
                                                setTheAccountNo(e.target.value);
                                            }}
                                            value={theAccountNo}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            This field is required
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label htmlFor="deliveryNo" className="required">
                                            Delivery # *
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            required
                                            id="deliveryNo"
                                            onChange={(e) => {
                                                setTheDisplayCd(e.target.value);
                                            }}
                                            value={theDisplayCd}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            This field is required
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <div className="mt-3">
                                        <Row>
                                            <div className="col-8 offset-2">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-block">
                                                    Check Status
                                                </button>
                                            </div>
                                        </Row>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                        <SmallCopyRight />
                    </div>
                </Row>
            </Container>
        </>
    );
};
const Styles = createGlobalStyle`
    html, body{
        background: #EBEEF1;
    }

`;
export default PublicStatusLoginPage;
